var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    [
      _c("v-card-title", [_vm._v(" Heimdall Deployment Statistics ")]),
      !_vm.loading
        ? _c(
            "div",
            [
              _c("v-simple-table", {
                attrs: { dark: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function () {
                        return [
                          _c(
                            "tbody",
                            _vm._l(_vm.statistics, function (value, name) {
                              return _c("tr", { key: name }, [
                                _c("td", [
                                  _vm._v(_vm._s(_vm.toCapitalizedWords(name))),
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(value.toLocaleString())),
                                ]),
                              ])
                            }),
                            0
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2039550381
                ),
              }),
            ],
            1
          )
        : _c(
            "div",
            [
              _c("v-progress-linear", {
                attrs: { indeterminate: "", size: 80, width: 20 },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }